/* eslint-disable */
import React, { Component } from "react";
import _ from "lodash";
import Scroll from "react-scroll";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fromJS, List, Map } from "immutable";
import { withRouter } from "react-router";
import classnames from "classnames";
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import { format } from "date-fns";
import {
  pushImpressionClickEvent,
  pushImpressionViewEvent,
  pushProductDetailEvent,
  pushRemoveFromCartEvent,
} from "../../helpers/EnhancedEcommerce";

import styles from "./styles.scss";
import { ArrowBackIcon, ArrowDropDownIcon, InfoWhiteIcon, PersonIcon } from "../../theme/assets";

import { EntityGrid, FixedCart, Package, Popup, Promotions } from "@witbooking/react-components";

import { actions } from "./reducer";
import { actions as appActions, selectors as appSelectors } from "../App";

import Notification from "../../components/Notification/Notification";
import constants, { BOOKING_FORM_NAME_MOUNTPOINT } from "../../utils/constants";
import {
  buildImgUrl,
  decorateUrl,
  executeEvent,
  filterDisplayElement,
  getFromSessionStorage,
  getLinkToLoyaltyLogin,
  handleGallery,
  redirectUrl,
  renderHTML,
  saveToSessionStorage,
} from "../../utils/misc";
import { dataUpdatedEvent, initGlobals, updateGlobalsOnARIRequest } from "./utils/initGlobals";

import { submitBookingForm } from "../BookingFormWrapper/utils";
import {
  actions as reservationActions,
  selectors as reservationSelectors,
} from "../ReservationManager";
import {
  accommodationSelectionBehaviorSelector,
  accommodationsSelector,
  activeChildrenMapSelector,
  activeDisplayElementSelector,
  activeEntitySelector,
  activePropertyARIFullRoomSelector,
  activePropertyDataFullRoomSelector,
  activePropertyTickerSelector,
  activeRoomsSelector,
  allAccommodationsSelector,
  arePromoCodesBeingAppliedSelector,
  bookableCardSizeSelector,
  bookingFormFieldsSelector,
  bookingFormInitialValuesSelector,
  bookingFormSelector,
  customDomainsSelector,
  displayActiveElementsSelector,
  displayElementParamSelector,
  filteredDisplayElementsSelector,
  guestAgesSelector,
  hasPremiumMapSelector,
  inventoriesSelector,
  isButtonBarActiveSelector,
  isCartMaxItemsReachedSelector,
  isEntityGridSelector,
  isOccupationIgnoredSelector,
  numberOfNightsSelector,
  openCalendarSelector,
  promoCodesSelector,
  propertyListAllSelector,
  propertyPromotionsImmutableSelector,
  propertyPromotionsSelector,
  propertySelectionBehaviorSelector,
  renderDisplayElementAsModalSelector,
  resultHeaderNatureUISelector,
  roomSelectionViewTypeSelector,
  showCalendarByUrlSelector,
  showCalendarSelector,
  showOccupationAlternativesSelector,
  showPromoCodesAppliedPopupDescriptionsSelector,
  showUnavailableModalMessageSelector,
  summaryCartSelector,
} from "./selectors";

import PropertyMapView from "./components/PropertyMapView/PropertyMapView";
import ARILoader from "./components/ARILoader/ARILoader";
import ModalMessage from "./components/ModalMessage/ModalMessage";
import TabFilter from "./components/TabFilter/TabFilter";
import EngineButtonBar from "./components/EngineButtonBar/EngineButtonBar";
import ContextualDisplay from "../../components/ContextualDisplay/ContextualDisplay";
import Footer from "../../components/Footer/Footer";
import SummaryCart from "../../components/SummaryCart/SummaryCart";
import VerticalPromotionList from "../../components/PromotionList/VerticalPromotionList";
import BookableErrorMessage from "../../components/BookableErrorMessage/BookableErrorMessage";
import { withSticky } from "../../components/StickyWrapper/StickyWrapper";
import Calendar from "../../components/Calendar/Calendar";
import AvailabilityNotification from "../../components/AvailabilityNotification/AvailabilityNotification";
import PriceWidgetPlaceholder from "../../components/PriceWidgetPlaceholder/PriceWidgetPlaceholder";
import PropertyList from "../../components/PropertyList/PropertyList";
import Property from "../../components/Property/Property";
import Room from "../../components/Room/Room";
import EntityCarousel from "../../components/EntityCarousel/EntityCarousel";
import InventoryList from "../../components/InventoryList/InventoryList";
import EntityResultHeader from "../../components/EntityResultHeader/EntityResultHeader";
import styled from "styled-components";
import { appMsgs } from "../App/App";
import media from "../../utils/media";
import { parse as queryStringParse } from "query-string";
import { ArrowContainer } from "../../utils/ArrowContainer";
import {
  assistedModeSelector,
  occupantRestrictionSelector,
  propertyFiltersSelector,
  showCollapsedRoomSelector,
  showNewBookingFormSelector,
} from "../App/selectors";
import Amount from "../../components/Amount/Amount";

const selectors = { ...appSelectors, ...reservationSelectors };

const Element = Scroll.Element;

const DisplayContainer = styled.div`
  height: 100%;
`;

const EntityResultHeaderComponentContainer = withSticky(styled.div`
  display: block;
  ${media.up.lg`
  display: none;
  `};
`);

const OnBackIconContainer = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: ${props => (props.hasBackButton ? `block` : `none`)};
  margin-right: 10px;
  svg {
    color: #908f96;
    &:hover {
      color: #3a3a3a;
    }
  }
`;

const StyledAvailabilityNotification = styled(AvailabilityNotification)`
  margin-bottom: 20px !important;
`;

const StyledNotification = styled(Notification)`
  margin-top: 0 !important;
  margin-bottom: 15px !important;
`;

const FooterContainer = styled.div`
  width: ${props =>
    props.arePromosBeingRendered
      ? "calc(100% - 24px - 195px - 13px - 13px - 24px + 1px);"
      : "calc(100% - 24px - 13px - 24px + 1px);"};
  ${media.down.mdl`
  width: 100%;

  `};
`;

function mapResizeHandler() {
  if (window.wbkMap && window.google) {
    window.google.maps.event.trigger(window.wbkMap, "resize");
  }
}

function handleEventPropagation(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
}

const StickyMapContainer = styled.div``;

const msgs = defineMessages({
  availability: {
    id: "room_selection.notification.availability",
    description: "Notification of availability on selected dates",
    defaultMessage: "Available for",
  },
  book: {
    id: "room_selection.notification.book",
    description: "book button",
    defaultMessage: "BOOK",
  },
  notAvailable: {
    id: "room_selection.notification.notAvailable",
    description: "Notification of availability on selected dates",
    defaultMessage: "Not available for",
  },
  nights: {
    id: "room_selection.notification.nights",
    description: "Notification of availability on selected dates",
    defaultMessage: "night/s",
  },
  showMap: {
    id: "room_selecton.map.show",
    description: "Button to show map",
    defaultMessage: "Show map",
  },
  hideMap: {
    id: "room_selecton.map.hide",
    description: "Button to hide map",
    defaultMessage: "Hide map",
  },
  perNight: {
    id: "room_selection.entity_type.night",
    description: "Price per night text",
    defaultMessage: "per night",
  },
  restricted: {
    id: "room_selection.hotel.restricted",
    description: "Restricted text",
    defaultMessage: "Restricted",
  },
  unavailable: {
    id: "room_selection.hotel.unavailable",
    description: "Unavailable text",
    defaultMessage: "Sold Out",
  },
  validCode: {
    id: "room_selection.hotel.validPromoCode",
    description: "Valid Code",
    defaultMessage: "Valid Code",
  },
  invalidCode: {
    id: "room_selection.hotel.invalidPromoCode",
    description: "invalid Code",
    defaultMessage: "Invalid Code",
  },
  discount: {
    id: "room_selection.hotel.discount",
    description: "Discount",
    defaultMessage: "Discount",
  },
  agesText: {
    id: "booking_form.ageSelector.childrenAges.description",
    description: "explanatory text for children ages selector",
    defaultMessage: "Ages of children at check-out",
  },
  resultsFor: {
    id: "occupancy.resultsFor",
    description: "text for results in search",
    defaultMessage: "results for",
  },
  resultFor: {
    id: "occupancy.resultFor",
    description: "text for a result in search",
    defaultMessage: "result for",
  },
  otherOptions: {
    id: "occupancy.otherOptions",
    description: "text for show other options in search",
    defaultMessage: "Other options",
  },
  adult: {
    id: "roomSelection.occupant.adult",
    description: "occupant type adult",
    defaultMessage: "adult",
  },
  adults: {
    id: "roomSelection.occupant.adults",
    description: "occupant type adults",
    defaultMessage: "adults",
  },
  senior: {
    id: "roomSelection.occupant.senior",
    description: "occupant type senior",
    defaultMessage: "senior",
  },
  seniors: {
    id: "roomSelection.occupant.seniors",
    description: "occupant type seniors",
    defaultMessage: "seniors",
  },
  teenager: {
    id: "roomSelection.occupant.teenager",
    description: "occupant type teenager",
    defaultMessage: "teenager",
  },
  teenagers: {
    id: "roomSelection.occupant.teenagers",
    description: "occupant type teenagers",
    defaultMessage: "teenagers",
  },
  child: {
    id: "roomSelection.occupant.child",
    description: "occupant type child",
    defaultMessage: "child",
  },
  children: {
    id: "roomSelection.occupant.children",
    description: "occupant type children",
    defaultMessage: "children",
  },
  baby: {
    id: "roomSelection.occupant.baby",
    description: "occupant type baby",
    defaultMessage: "baby",
  },
  babies: {
    id: "roomSelection.occupant.babies",
    description: "occupant type babies",
    defaultMessage: "babies",
  },
  guest: {
    id: "roomSelection.occupant.guest",
    description: "occupant type guest",
    defaultMessage: "guest",
  },
  guests: {
    id: "roomSelection.occupant.guests",
    description: "occupant type guests",
    defaultMessage: "guests",
  },
  promoCodeSelected: {
    id: "promoPopup.header",
    defaultMessage: "Code entered (review application conditions)",
  },
  multiplePromotionsAdvice: {
    id: "promoPopup.multiplePromotionsAdvice",
    defaultMessage: "*Promotions may not be cumulative",
  },
});

const StickyRightContainer = withSticky(VerticalPromotionList);

class RoomSelection extends Component {
  static showPromoCodeAlert(props) {
    if (props.arePromoCodesBeingApplied) {
      props.addAlert("success", props.intl.formatMessage(msgs.validCode), null, {
        positionClass: "toast-top-center",
      });
      if (
        props.showPromoCodesAppliedPopupDescriptions &&
        props.showPromoCodesAppliedPopupDescriptions.size > 0
      ) {
        this.handlePromoCodesDescriptionsModal(props);
      }
    } else {
      props.addAlert("error", props.intl.formatMessage(msgs.invalidCode), null, {
        positionClass: "toast-top-center",
      });
    }
  }

  static handlePromoCodesDescriptionsModal(props) {
    const promoCodesApplied = Array.from(props.showPromoCodesAppliedPopupDescriptions).map(
      ([key]) => key
    );
    const promotions = props.propertyPromotions.filter(it => promoCodesApplied.includes(it.ticker));
    if (promotions.length > 0) {
      return props.handleModalContent(
        <Promotions
          headerText={<FormattedMessage {...msgs.promoCodeSelected} />}
          headerIcon={<InfoWhiteIcon />}
          footer={
            <div style={{ padding: 20, fontSize: "12px" }}>
              <FormattedMessage {...msgs.multiplePromotionsAdvice} />
            </div>
          }
          promotions={promotions}
          closeWindow={props.handleCloseModal}
          BookableErrorMessage={BookableErrorMessage}
          currency={props.currency}
          textColor={`#${props.customStyles.get("bookingFormButtonBackgroundColor")}`}
          inverseTextColor={`#${props.customStyles.get("bookingFormButtonOppositeColor")}`}
        />,
        { className: "fullContent" }
      );
    }
  }

  constructor(props) {
    super(props);
    const showOccupationAlternatives =
      props.showOccupationAlternatives || constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED;
    this.state = {
      isModalOpen: props.messages && props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_1),
      markerSelected: null,
      hotelSelected: null,
      largeBookingForm: false,
      reservationAdded: false,
      isPropertyCalendarOpened: true,
      allAccommodationsFiltered: [],
      showOccupationAlternatives,
      selectedElementOutside: "",
      deviceType: constants.DEVICE_TYPE.DESKTOP,
      selectedRoom: null,
    };
    this.handleSubmitBookingForm = this.handleSubmitBookingForm.bind(this);
    this.handlePropertySelectInMap = this.handlePropertySelectInMap.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleMarkerOnHover = this.handleMarkerOnHover.bind(this);
    this.handleMarkerOnMouseLeave = this.handleMarkerOnMouseLeave.bind(this);
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.handleSelectorChangeTab = this.handleSelectorChangeTab.bind(this);
    this.applyExpandableParams = this.applyExpandableParams.bind(this);
    this.handleChangeLocale = this.handleChangeLocale.bind(this);
    this.handleChangeConfiguration = this.handleChangeConfiguration.bind(this);
    this.handleGoToCheckout = this.handleGoToCheckout.bind(this);
    this.handleRemoveReservation = this.handleRemoveReservation.bind(this);
    this.handleSelectActiveDisplayElement = this.handleSelectActiveDisplayElement.bind(this);
    this.handleSelectProperty = this.handleSelectProperty.bind(this);
    this.handleResetProperty = this.handleResetProperty.bind(this);
    this.handleSelectEntity = this.handleSelectEntity.bind(this);
    this.handleResetAccommodation = this.handleResetAccommodation.bind(this);
    this.handleOpenPropertyCalendar = this.handleOpenPropertyCalendar.bind(this);
    this.handleOpenPromotions = this.handleOpenPromotions.bind(this);
    this.generatePropertyMapView = this.generatePropertyMapView.bind(this);
    this.handleOpenMap = this.handleOpenMap.bind(this);
  }

  activateModalMessage = ({ props }) => {
    if (props.messages && props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_1)) {
      const onCloseModal = () => {
        saveToSessionStorage(
          constants.LOCAL_STORAGE_KEYS.SHOW_ON_UNAVAILABLE,
          JSON.stringify({ [props.propertyTicker]: true })
        );
        this.handleOpenPropertyCalendar({
          propertyTicker: props.propertyTicker,
        });
      };
      if (
        props.showUnavailableModalMessage &&
        props.messages &&
        props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_2)
      ) {
        props.handleModalContent(
          <ModalMessage
            messages={props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_2)}
            onCloseModal={() => {
              onCloseModal();
              props.handleCloseModal();
            }}
          />,
          {
            hideCloseButton: true,
            onClose: onCloseModal,
          }
        );
      }
    }
  };

  areExpandedTickersValid({ expandables, propertyList, entityType }) {
    const [propertyTicker, entityTicker] = expandables;
    const entitiesType = `${entityType}s`;

    const validPropertyTicker = propertyList
      .filter(property => property.get("ticker") === propertyTicker)
      .map(property => property && property.get("ticker"))
      .find(it => it);

    const validEntityTicker = propertyList
      .filter(property => property.get("ticker") === propertyTicker)
      .map(
        property =>
          property && property.get(entitiesType) && property.get(entitiesType).keySeq().toList()
      )
      .reduce((acc, it) => acc.concat(it), new List())
      .filter(ticker => ticker === entityTicker)
      .find(it => it);

    return [validPropertyTicker, validEntityTicker];
  }

  doesPropertyHaveInventories({ propertyList, propertyTicker }) {
    let hasInventories = true;
    if (propertyList && propertyList.length > 0) {
      let propertyToExpand = propertyList.filter(
        property => property.get("ticker") === propertyTicker
      );
      if (propertyToExpand && propertyToExpand.length > 0) {
        propertyToExpand = propertyToExpand[0];
        hasInventories = propertyToExpand.get("inventories").size > 0;
      }
    }
    return hasInventories;
  }

  applyDisplayElementParam({ props, previousProps }) {
    if (
      (props.displayElementParam && (!previousProps || !previousProps.displayElementParam)) ||
      (previousProps && previousProps.displayElementParam !== props.displayElementParam)
    ) {
      this.handleSelectActiveDisplayElement({
        element: props.displayElementParam,
        renderAsModal: !props.isDisplayActive,
      });
    }
  }

  setMapHeight() {
    if (!this.mapHeight || this.mapHeight < 0) {
      // New booking form height
      const bookingFormHeight = this.props.showNewBookingForm ? 140 : 0;
      const loyaltyHeight = Boolean(this.props.loyalty) ? 50 : 0;
      this.mapHeight =
        window.innerHeight -
        document.getElementById("hotelCardContainer").getBoundingClientRect().top -
        (80 + loyaltyHeight) -
        bookingFormHeight;
    }
    const stickyMap = document.getElementById("stickyMap");
    const stickyVerticalPromotionList = document.getElementById("stickyVerticalPromotionList");
    if (stickyMap && stickyMap.offsetHeight !== this.mapHeight) {
      stickyMap.setAttribute("style", "height:" + this.mapHeight + "px");
    }
    if (
      stickyVerticalPromotionList &&
      stickyVerticalPromotionList.offsetHeight !== this.mapHeight
    ) {
      stickyVerticalPromotionList.setAttribute("style", "height:" + this.mapHeight + "px");
    }
    if (stickyVerticalPromotionList && this.props.propertyPromotionsImmutable.size === 0) {
      stickyVerticalPromotionList.setAttribute("style", "max-height: 100px");
    }
  }

  componentDidMount() {
    //Clears any previously loaded reservations (if coming from booking confirmation or modification)
    this.props.clearLoadedReservations();

    this.applyExpandableParams({ props: this.props });

    this.applyDisplayElementParam({ props: this.props });

    this.activateModalMessage({ props: this.props });

    this.setMapHeight();

    this.setMapHeight();

    initGlobals(this.props);

    const DefaultModalText = styled.div`
      padding: 10px 30px;
      color: #908f96;
    `;

    /** if messages exists gets all the ones from STEP 1, then proceeds to check if one has the code modalAgente, in case to be true it renders the modal with the corresponding content*/
    const messages =
      this.props.messages && this.props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_1);

    // we ignore the unavailable messages, and instead handle them on step1
    messages &&
      messages
        .filter(it => !it.showOnUnavailable)
        .map(message => {
          let popupProps;
          switch (message.get("code")) {
            case "modalAgent":
              popupProps = {
                closeWindow: this.props.handleCloseModal,
                headerText: <FormattedMessage {...appMsgs.agentsTitle} />,
                srcLogo: <PersonIcon />,
              };
              break;
            default:
              popupProps = {
                closeWindow: this.props.handleCloseModal,
                srcLogo: <InfoWhiteIcon />,
              };
              break;
          }
          this.props.handleModalContent(
            <Popup {...popupProps}>
              <DefaultModalText dangerouslySetInnerHTML={{ __html: message.get("content") }} />
            </Popup>,
            {
              hideCloseButton: true,
            }
          );
        });
    // Get all accommodations for more options section
    if (
      this.props.accommodations &&
      this.props.allAccommodations &&
      this.props.allAccommodations.size
    ) {
      this.filterAllAccommodations();
    }
    this.setDeviceType();
  }

  setDeviceType() {
    if (this.props.windowWidth) {
      const deviceType =
        this.props.windowWidth >= constants.RESOLUTION.MD
          ? constants.DEVICE_TYPE.DESKTOP
          : constants.DEVICE_TYPE.MOBILE;

      if (this.state.deviceType !== deviceType) {
        this.setState({
          deviceType,
        });
      }
    }
  }

  handleGoToCheckout() {
    this.props.history.push({
      pathname: `/${this.props.propertyTicker}/checkout`,
      state: { hideExtrasModal: true },
    });
  }

  handleRemoveReservation(reservation) {
    pushRemoveFromCartEvent(this.props.propertyTicker, [
      {
        ticker: reservation.accommodationTicker,
        title: reservation.accommodationName,
        configurationName: reservation.configuration,
        mealPlanName: reservation.mealPlan,
        conditionName: reservation.condition,
        quantity: reservation.quantity,
        totalRate: reservation.totalRate,
      },
    ]);
    this.props.removeReservation({
      id: reservation.id,
      propertyTicker: this.props.propertyTicker,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.reservations &&
      prevProps.reservations !== this.props.reservations &&
      this.state.reservationAdded &&
      this.props.reservations.get(this.props.propertyTicker) &&
      this.props.reservations.get(this.props.propertyTicker).size > 0
    ) {
      executeEvent(constants.EVENTS.ADDED_RESERVATION);
      if (!this.props.assistedMode) {
        this.props.history.push(`/${this.props.propertyTicker}/checkout`);
      }
      return;
    }
    // if there's no active entity go back to base entity
    // because there are no results to display
    if (!this.props.activeEntity && prevProps.activeEntity !== this.props.activeEntity) {
      this.handleResetAccommodation({});
      return;
    }

    // if active entity is accommodation and there are no inventories
    // go back to base entity because there are no results to display
    if (
      this.props.activeEntity &&
      (this.props.activeEntity.type === constants.ACTIVE_ENTITY_TYPE.ACCOMMODATION ||
        this.props.activeEntity.type === constants.ACTIVE_ENTITY_TYPE.PACKAGE) &&
      (!this.props.inventories ||
        (this.props.inventories &&
          this.props.inventories !== prevProps.inventories &&
          this.props.inventories.size < 1))
    ) {
      this.handleResetAccommodation({});
      return;
    }

    // if entering to inventor list execute the expanded
    // inventory event
    if (
      this.props.activeEntity &&
      prevProps.activeEntity &&
      this.props.activeEntity.type !== prevProps.activeEntity.type
    ) {
      switch (this.props.activeEntity.type) {
        case constants.ACTIVE_ENTITY_TYPE.CHAIN:
          if (this.props.bMindTracker) {
            executeEvent(constants.EVENTS.CONTINUE_STEP_ZERO);
          } else {
            executeEvent(constants.EVENTS.START_STEP_ZERO);
          }
          break;

        case constants.ACTIVE_ENTITY_TYPE.HOTEL:
          executeEvent(constants.EVENTS.START_STEP_ONE);
          if (
            this.props.accommodations &&
            this.props.accommodations.get(this.props.propertyTicker)
          ) {
            pushImpressionViewEvent(
              this.props.accommodations.get(this.props.propertyTicker).toJS()
            );
          }
          break;

        case constants.ACTIVE_ENTITY_TYPE.ACCOMMODATION:
        case constants.ACTIVE_ENTITY_TYPE.PACKAGE:
          executeEvent(constants.EVENTS.START_STEP_TWO);
          const activeRoomTicker =
            this.props.activeRooms && this.props.activeRooms.get(this.props.propertyTicker);
          const activeRoom =
            this.props.accommodations &&
            this.props.accommodations.get(this.props.propertyTicker) &&
            this.props.accommodations
              .get(this.props.propertyTicker)
              .find(accommodation => accommodation.ticker === activeRoomTicker);
          if (activeRoom) {
            pushProductDetailEvent(this.props.propertyTicker, [activeRoom]);
          }
          break;

        default:
          break;
      }
    }

    if (this.props.ariLoading !== prevProps.ariLoading && !this.props.ariLoading) {
      updateGlobalsOnARIRequest(this.props);
    }

    if (this.props.invalidPayments) {
      return;
    }

    // FIXME: at the moment, if you search for a date in booking form and there is no availability, the calendar opens,
    // if you close it and search for other dates in booking form that don't have availability,
    // the calendar doesn't open again
    if (
      prevProps.expandedBookables !== this.props.expandedBookables ||
      prevProps.entityTypeBookables !== this.props.entityTypeBookables ||
      prevProps.isPropertyAvailable !== this.props.isPropertyAvailable ||
      (!this.props.propertyTabs && prevProps.propertyTabs)
    ) {
      this.applyExpandableParams({
        props: this.props,
      });
    }

    this.applyDisplayElementParam({
      props: this.props,
      previousProps: prevProps,
    });

    if (prevProps.activeChildrenMap !== this.props.activeChildrenMap) {
      dataUpdatedEvent(this.props.activeChildrenMap, this.props.externalConfiguration);
    }

    // New ARI REQUEST this.props.ariLoading === true && nextProps.ariLoading === false
    // Happens of first Load only this.props.locale === nextProps.intl.locale
    /* TODO: This is awful for such a simple behaviour */
    if (!this.state.firstLoadDone) {
      if (
        ((prevProps.ariLoading === true && this.props.ariLoading === false) ||
          this.props.locale === this.props.intl.locale) &&
        this.props.arePromoCodesBeingApplied !== null
      ) {
        RoomSelection.showPromoCodeAlert(this.props);
        this.setState({ firstLoadDone: true });
      } else if (this.props.arePromoCodesBeingApplied === null) {
        this.setState({ firstLoadDone: true });
      }
    } else {
      if (
        prevProps.ariLoading === true &&
        this.props.ariLoading === false &&
        this.props.arePromoCodesBeingApplied !== null
      ) {
        RoomSelection.showPromoCodeAlert(this.props);
      }
    }
    if (this.props.messages && prevProps.messages !== this.props.messages) {
      this.activateModalMessage({ props: this.props });
    }

    if (
      !_.isEqual(this.props.accommodations, prevProps.accommodations) &&
      this.props.allAccommodations &&
      this.props.allAccommodations.size
    ) {
      this.filterAllAccommodations();
    }
    if (
      !_.isEqual(this.props.allAccommodations, prevProps.allAccommodations) &&
      this.props.allAccommodations &&
      this.props.allAccommodations.size
    ) {
      this.filterAllAccommodations();
    }
    if (
      this.props.showOccupationAlternatives !== prevProps.showOccupationAlternatives &&
      this.props.showOccupationAlternatives ===
        constants.SHOW_OCCUPATION_ALTERNATIVES.NO_AVAILABILITY
    ) {
      this.filterAllAccommodations();
    }
    if (this.props.windowWidth !== prevProps.windowWidth) {
      this.setDeviceType();
    }
  }

  componentWillUnmount() {
    // TODO: what is this? is this necessary?
    this.props.handleExpandPromotions && this.props.handleExpandPromotions(false);
  }

  filterAllAccommodations() {
    // show occupation alternatives if there are filtered accommodations
    let flagShowOccupationAlternatives = false;
    // check if there are availability in accommodations
    let flagAvailability = false;
    let showOccupationAlternatives = this.state.showOccupationAlternatives;
    const originalShowOccupationAlternatives =
      this.props.showOccupationAlternatives || constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED;
    const allAccommodations = this.props.allAccommodations.toJS();
    const allAccommodationsFiltered = Object.keys(allAccommodations).reduce((result, ticker) => {
      const allAccommodationsByTicker = this.props.allAccommodations.toJS()[ticker];
      const actualAccommodations = this.props.accommodations.toJS()[ticker] || [];
      const actualAccommodationsIsAvailable = actualAccommodations.find(
        a => a.statusCode !== constants.BOOKABLE_STATUS.UNAVAILABLE
      );
      if (actualAccommodationsIsAvailable) {
        flagAvailability = true;
      }
      const filteredAccommodations = allAccommodationsByTicker.reduce(
        (accommodations, accommodation) => {
          const existAccomodation = actualAccommodations.find(
            a => a.ticker === accommodation.ticker
          );
          if (!existAccomodation) {
            accommodations = [...accommodations, accommodation];
          }
          return accommodations;
        },
        []
      );
      if (filteredAccommodations.length) {
        flagShowOccupationAlternatives = true;
      }
      result = {
        ...result,
        [ticker]: [...filteredAccommodations],
      };
      return result;
    }, {});
    if (
      flagShowOccupationAlternatives &&
      originalShowOccupationAlternatives === constants.SHOW_OCCUPATION_ALTERNATIVES.NO_AVAILABILITY
    ) {
      showOccupationAlternatives = flagAvailability
        ? constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE
        : constants.SHOW_OCCUPATION_ALTERNATIVES.EXPANDED;
    } else if (!flagShowOccupationAlternatives) {
      showOccupationAlternatives = constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE;
    }
    this.setState({
      allAccommodationsFiltered: fromJS(allAccommodationsFiltered),
      showOccupationAlternatives,
    });
  }

  handlePropertySelectInMap(propertyTicker) {
    this.handleSelectProperty({ propertyTicker });
    this.props.handleCloseModal();
  }

  handleModal(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.setState({ isModalOpen: false });
    return false;
  }

  /*TODO: THIS IS WRONG, I SHOULD BE USING THE DATA PARAM THAT THE FUNCTION RECEIVES!! */
  handleSubmitBookingForm({
    startDate,
    endDate,
    propertyTicker: callingTicker,
    formValues,
    guestAges: ageSelectorGuestAges,
  }) {
    submitBookingForm({
      startDate,
      endDate,
      propertyTicker: callingTicker,
      formValues,
      guestAges: ageSelectorGuestAges,
      bookingFormFields: this.props.bookingFormFields,
      locale: this.props.configuration.get("locale"),
      globalPropertyTicker: this.props.propertyTicker,
      addAlert: this.props.addAlert,
      requestARI: this.props.requestARI,
      bookingForm: this.props[BOOKING_FORM_NAME_MOUNTPOINT],
      push: this.props.history.push,
      promoCodes: this.props.promoCodes,
      sessionId: this.props.restoredSession && this.props.restoredSession.id,
    });
  }

  handleMarkerOnHover(ticker) {
    this.setState({ markerSelected: ticker });
  }

  handleMarkerOnMouseLeave() {
    this.setState({ markerSelected: null });
  }

  handleChangeTab(tab) {
    const requestParams = {
      locale: this.props.configuration.get("locale"),
      propertyTicker: this.props.propertyTicker,
      selectedTab: tab,
    };
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: fromJS(requestParams),
    });
  }

  handleSelectorChangeTab(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const requestParams = {
      locale: this.props.configuration.get("locale"),
      propertyTicker: this.props.propertyTicker,
      selectedTab: event.target.value,
    };
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: fromJS(requestParams),
    });
  }

  handleChangeConfiguration(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
  }

  handleChangeLocale(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
    this.props.changeLocale({
      propertyTicker: this.props.propertyTicker,
      locale: newConfiguration.locale,
    });
  }

  handleImagePackage = (element, title, description) => {
    const functionMapper = handleGallery(this.props.handleModalContent, this.props.handleGallery);
    functionMapper(
      [
        {
          url: element,
        },
      ],
      title,
      description,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    );
  };

  handleSelectedRoomChange = room => {
    this.setState({
      selectedRoom: room,
    });
  };

  //------------------------ NEW METHODS  -----------------------------\\
  onNoExpanded = props => {
    this.props.resetProperty({ propertyTicker: props.propertyTicker });
    const shouldItBeShownByProperty =
      !props.isPropertyAvailable && !props.showUnavailableModalMessage && !props.assistedMode;
    if (props.showCalendarByUrl || shouldItBeShownByProperty) {
      this.handleSelectActiveDisplayElement({
        element: "availability",
        renderAsModal: props.showCalendarByUrl,
      });
    }
  };

  applyExpandableParams({ props }) {
    if (!props.expandedBookables || props.noExpand) {
      this.onNoExpanded(props);
      return;
    }

    const activeEntities = props.expandedBookables.split(";") || [];
    // There can only be one active Property or a Property's Accommodation at the same time
    const activeEntity = activeEntities[0];
    const entityType = props.entityTypeBookables || "accommodation";
    if (!activeEntity) {
      this.onNoExpanded(props);
      return;
    }

    const [propertyTicker, entityTicker] = this.areExpandedTickersValid({
      expandables: activeEntity.split(","),
      propertyList: props.propertyAriAll ? props.propertyListAll : props.propertyList,
      entityType,
    });
    if (!propertyTicker) {
      this.onNoExpanded(props);
      return;
    }

    if (entityTicker) {
      if (props.propertyActiveTab) {
        this.handleChangeTab(props.propertyActiveTab.get("optionTicker"));
      }
      if (entityType === "accommodation") {
        this.props.selectAccommodation({ propertyTicker, accommodationTicker: entityTicker });
        return;
      } else if (entityType === "package") {
        this.props.selectPackage({ propertyTicker, packageTicker: entityTicker });
        return;
      }
    }

    const hasInventories = this.doesPropertyHaveInventories({
      propertyList: props.propertyAriAll ? props.propertyListAll : props.propertyList,
      propertyTicker,
    });

    const activateCalendar = !(hasInventories && props.isPropertyAvailable);

    if (activateCalendar) {
      this.handleSelectActiveDisplayElement({ element: "availability" });
      this.props.selectProperty({ propertyTicker });
      return;
    }

    this.props.selectProperty({ propertyTicker });
  }

  calculateParams = () => {
    let queryParams =
      (this.props.location &&
        this.props.location.search &&
        queryStringParse(this.props.location.search)) ||
      {};

    queryParams = { ...queryParams };

    let urlPath = "&";
    if (
      this.props.openCalendar &&
      !getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX)
    ) {
      queryParams.openCalendar = 1;
    }

    if (this.props.promoCodes) {
      queryParams.prom = this.props.promoCodes;
    }

    // CLEAN ALL PREVIOUS URL PARAMS
    delete queryParams.seniors;
    delete queryParams.adults;
    delete queryParams.adultos;
    delete queryParams.teenagers;
    delete queryParams.children;
    delete queryParams.babies;
    delete queryParams.bebes;
    delete queryParams.personas;
    delete queryParams.expand;
    delete queryParams.entityType;
    //TODO Sacar todo esto de this.props, no de window!!
    // ADD ALL BOOKING FORM PARAMS
    queryParams.adults = window.wbkAdults;
    queryParams.seniors = window.wbkSeniors;
    queryParams.babies = window.wbkBabies;
    queryParams.teenagers = window.wbkTeenagers;
    queryParams.children = window.wbkChildren;
    queryParams.datein = window.wbkStartDate;
    queryParams.dateout = window.wbkEndDate;
    queryParams.guestAges = window.guestAges || this.props.bookingFormInitialValues.guestAges;
    queryParams.origin = window.wbkOrigin;
    queryParams.mode = window.wbkMode;
    queryParams.affiliate = window.wbkAffiliate;

    const queue = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE);
    const ages = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_AGES);
    if (window.wbkStay) {
      queryParams.stay = window.wbkStay;
    } else if (this.props.assistedMode && queue && queue.length) {
      const assistedModeQuery = queue.reduce((query, occupants, index) => {
        const { adults, children, seniors, teenagers, babies } = occupants;
        const transformedString =
          Array.isArray(ages) &&
          ages.some(it => {
            return Array.isArray(it) && it.length;
          })
            ? `${adults}[${ages[index] && ages[index].join(",")}]`
            : `${adults},${children},${seniors},${teenagers},${babies}`;
        return `${query}${query ? "&stay=" : ""}${transformedString}`;
      }, "");
      if (assistedModeQuery) {
        queryParams.stay = assistedModeQuery;
      }
    }

    for (let key in queryParams) {
      if (queryParams.hasOwnProperty(key) && queryParams[key]) {
        queryParams[key] && Array.isArray(queryParams[key])
          ? queryParams[key].map(value => {
              urlPath += key + "=" + value + "&";
            })
          : (urlPath += key + "=" + queryParams[key] + "&");
      }
    }
    return urlPath;
  };

  pushRoutes({ mainProperty, childProperty, entity, calledFrom, displayElementTicker }) {
    let newPath = "";
    let ticker = "";

    switch (calledFrom) {
      case constants.SELECT_BEHAVIOR_TYPE.ACCOMMODATION:
        ticker =
          this.props.accommodationSelectionBehavior === ""
            ? this.props.propertyTicker
            : childProperty;
        newPath = `/${ticker}/availability/?`;
        break;
      case constants.SELECT_BEHAVIOR_TYPE.PROPERTY: {
        /** Differenciate if the property it's unavailable and in affirmative case run the function handleOpenPropertyCalendar then make a return*/
        ticker =
          this.props.propertySelectionBehavior === "" ? this.props.propertyTicker : childProperty;
        const statusCode = this.props.propertyList
          .find(it => it.get("ticker") === childProperty)
          .get("lastStatus")
          .get("code");
        const isUnavailable = statusCode === constants.PROPERTY_STATUS.UNAVAILABLE;
        if (isUnavailable) {
          this.handleOpenPropertyCalendar({ propertyTicker: childProperty });
          return;
        }
        newPath = `/${ticker}/availability/?`;
        break;
      }
      default:
        newPath = `/${mainProperty || this.props.propertyTicker}/availability/?`;
        break;
    }
    const params = this.calculateParams();
    if (childProperty && entity) {
      newPath = `${newPath}expand=${childProperty},${entity}${params}`;
      if (displayElementTicker) {
        newPath += `displayElement=${displayElementTicker}`;
      }
      if (!newPath.includes("entityType=")) {
        newPath += `entityType=${calledFrom.toLowerCase()}`;
      }
    } else if (childProperty) {
      newPath = `${newPath}expand=${childProperty}${params}`;
    }

    if (calledFrom === constants.SELECT_BEHAVIOR_TYPE.ACCOMMODATION) {
      this.redirectToProperty(newPath, this.props.accommodationSelectionBehavior);
    } else {
      this.redirectToProperty(newPath, this.props.propertySelectionBehavior);
    }
  }

  redirectToProperty = (newUrl, selectionBehavior) => {
    switch (selectionBehavior) {
      case constants.SELECTION_BEHAVIOR.DESKTOP_NEW_TAB:
        if (window.innerWidth > 768) {
          const newTab = window.open(decorateUrl(newUrl), "_blank");
          newTab.focus();
        } else {
          redirectUrl(newUrl);
        }
        break;

      case constants.SELECTION_BEHAVIOR.SAME_TAB:
        redirectUrl(newUrl);
        break;

      case constants.SELECTION_BEHAVIOR.NEW_TAB:
        const newTab = window.open(decorateUrl(newUrl), "_blank");
        newTab.focus();
        break;

      default:
        this.props.history.push(newUrl);
    }
  };

  handleSelectActiveDisplayElement({ element, renderAsModal, selectedOutside }) {
    if (element !== "availability" || (element === "availability" && this.props.showCalendar)) {
      this.props.selectActiveDisplayElement({ element, renderAsModal });
    }
    const selectedElementOutside = selectedOutside ? element : "";
    this.setState({ selectedElementOutside });
  }

  handleSelectProperty({ event, propertyTicker }) {
    this.pushRoutes({
      childProperty: propertyTicker,
      calledFrom: constants.SELECT_BEHAVIOR_TYPE.PROPERTY,
    });
  }

  setOriginAccommodation({ originAccommodation }) {
    this.props.setOriginAccommodation({ originAccommodation });
  }

  handleSelectEntity({
    ticker,
    entity,
    displayElementTicker,
    originAccommodation,
    type = "accommodation",
  }) {
    window.scrollTo(0, 0);
    this.setOriginAccommodation({ originAccommodation });
    this.pushRoutes({
      calledFrom:
        type === "accommodation"
          ? constants.SELECT_BEHAVIOR_TYPE.ACCOMMODATION
          : constants.SELECT_BEHAVIOR_TYPE.PACKAGE,
      childProperty: ticker,
      entity,
      displayElementTicker,
    });
  }

  handleResetProperty({ event }) {
    handleEventPropagation(event);
    this.pushRoutes({});
  }

  handleResetAccommodation({ event }) {
    handleEventPropagation(event);
    if (this.props.isPropertyChain) {
      this.pushRoutes({
        childProperty: this.props.activePropertyTicker,
      });
    } else {
      this.pushRoutes({});
    }
  }

  handleInventorySelected({
    propertyTicker,
    inventory,
    numberOfUnits,
    propertyServices,
    selectedPackage,
  }) {
    this.props.changePropertyTicker(propertyTicker);
    /* I need to access services HERE because i have to mark obligatory services as Selected */
    const obligatoryServices =
      (inventory.get("services") &&
        inventory.get("services").reduce((accumulator, ticker) => {
          if (propertyServices.get(ticker) && propertyServices.get(ticker).get("obligatory")) {
            accumulator[ticker] = { quantity: 1 };
          }
          return accumulator;
        }, {})) ||
      {};

    let guestAgesText = null;

    if (this.props.guestAges && this.props.guestAges.size > 0) {
      guestAgesText =
        this.props.intl.formatMessage(msgs.agesText) +
        ": " +
        this.props.guestAges.toJS().join(", ");
    }
    const reservation = fromJS({
      id: `P${Math.ceil(Math.random() * 1000000000000000)}`,
      inventory: inventory.get("ticker"),
      paymentTypes: inventory.get("paymentTypes").map(paymentType => paymentType.get("type")),
      baseRate: inventory.get("originalRates").get("originalRate"),
      stayRate: inventory.get("originalRates").get("totalRate"),
      totalRate: inventory.get("originalRates").get("totalRate"),
      originalRate: inventory.get("originalRates").get("originalRate"),
      discountAmount:
        inventory.get("originalRates").get("discountAmount") &&
        inventory.get("originalRates").get("discountAmount"),
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      selectedServices: obligatoryServices,
      propertyTicker,
      numberOfUnits,
      promoCodes: this.props.promoCodes,
      guestAgesText: guestAgesText,
      guestAges: this.props.guestAges,
      selectedPackage: selectedPackage ? selectedPackage.ticker : "",
    });
    const reservationARI = new Map().setIn(
      [reservation.get("id"), propertyTicker],
      (this.props.propertyAriAll ? this.props.propertyAriAll : this.props.ARI).get(propertyTicker)
    );
    this.setState({ reservationAdded: true });

    if (this.props.assistedMode && typeof this.props.stayQueueIndex === "number") {
      this.props.setStayQueueIndex(this.props.stayQueueIndex + 1);
      saveToSessionStorage(
        constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX,
        this.props.stayQueueIndex + 1
      );
    }

    this.props.addReservation(propertyTicker, reservation, reservationARI);

    this.props.resetAccommodation({ propertyTicker });

    window.wbkConditionName = inventory.get("condition").get("name");
    window.wbkMealPlan = inventory.get("mealplan").get("name");
  }

  handleOpenPropertyCalendar({ propertyTicker, onCalendarClose }) {
    let submitTicker = propertyTicker;

    const activeEntityType = this.props.activeEntity && this.props.activeEntity.type;
    if (
      activeEntityType === constants.ACTIVE_ENTITY_TYPE.CHAIN ||
      activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL
    ) {
      submitTicker = this.props.activeEntity.ticker;
    }
    const property = this.props.propertyList.find(item => item.get("ticker") === propertyTicker);

    return this.props.handleModalContent(
      <Calendar
        initialStartDate={this.props.startDate}
        initialEndDate={this.props.endDate}
        currency={this.props.currency}
        onSubmit={data => {
          this.props.handleCloseModal();
          this.handleSubmitBookingForm({
            ...data,
            propertyTicker: submitTicker,
          });
        }}
        showDiscountsCalculation={this.props.showDiscountsCalculation}
        propertyTicker={propertyTicker}
        priceCalendar={this.props.priceCalendar}
        property={property}
        handleCloseModal={this.props.handleCloseModal}
        changeConfiguration={this.props.changeConfiguration}
      />,
      {
        className: "wbkv9-Modal-calendar",
        onClose: onCalendarClose || undefined,
        hideCloseButton: true,
      }
    );
  }

  handleOpenPromotions() {
    return this.props.handleModalContent(
      <Promotions
        promotions={this.props.propertyPromotions}
        closeWindow={this.props.handleCloseModal}
        BookableErrorMessage={BookableErrorMessage}
        currency={this.props.currency}
        textColor={`#${this.props.customStyles.get("bookingFormButtonBackgroundColor")}`}
        inverseTextColor={`#${this.props.customStyles.get("bookingFormButtonOppositeColor")}`}
      />,
      { className: "fullContent" }
    );
  }

  generatePropertyMapView() {
    const list =
      (this.props.isPropertyChain &&
        this.props.propertyTicker !== this.props.activePropertyTicker &&
        this.props.propertyList.filter(
          property => property.get("ticker") === this.props.activePropertyTicker
        )) ||
      this.props.propertyList;

    return (
      <PropertyMapView
        handlePropertySelectInMap={this.handlePropertySelectInMap}
        hotelSelected={this.state.hotelSelected}
        handleMarkerOnHover={this.handleMarkerOnHover}
        handleMarkerOnMouseLeave={this.handleMarkerOnMouseLeave}
        propertyList={list}
        numberOfNights={this.props.numberOfNights}
        currency={this.props.currency}
        hasPremiumMap={this.props.hasPremiumMap}
      />
    );
  }

  handleOpenMap() {
    return this.props.handleModalContent(this.generatePropertyMapView(), {
      mobileMode: true,
      className: "wbkv9-Modal-mapModal",
    });
  }

  getFirstNightCost = ticker => {
    try {
      const propertyList =
        this.props.propertyListAll?.size || this.props.propertyListAll?.length
          ? this.props.propertyListAll
          : this.props.propertyList;
      return propertyList
        .find(it => it.get("ticker") === this.props.propertyTicker)
        ?.getIn(["inventories", ticker, "firstNightCost"]);
    } catch (e) {
      return (this.props.propertyAriAll ? this.props.propertyAriAll : this.props.ARI).getIn([
        this.props.propertyTicker,
        "arivalues",
        ticker,
        "firstNightCost",
      ]);
    }
  };

  getRooms = ({
    entities,
    entityFilter,
    activeEntityTicker,
    originAccommodation = "base",
    showOccupationAlternatives,
    linkToLoyaltyLogin,
    taxesText,
  }) => {
    const {
      filteredDisplayElements,
      isDisplayActive,
      accommodationSelectionBehavior,
      handleScroll,
      windowWidth,
      propertyFilters,
      isEntityGrid,
      accommodations,
      propertyTicker,
      onlineStoreHidePrice,
    } = this.props;
    let rooms;
    if (entities && entities.size && entities.get(activeEntityTicker)) {
      const handleImpressionClickEvent = accommodationTicker => {
        let activeRoomIndex = 0;
        const activeRoom =
          accommodations &&
          accommodations.get(propertyTicker) &&
          accommodations.get(propertyTicker).find((accommodation, index) => {
            activeRoomIndex = index;
            return accommodation.ticker === accommodationTicker;
          });
        if (activeRoom) {
          pushImpressionClickEvent([
            {
              ticker: activeRoom.ticker,
              title: activeRoom.title,
              minPrice: activeRoom.minPrice,
              position: activeRoomIndex,
            },
          ]);
        }
      };

      const getOccupants = (activeEntityTicker, ARI) => {
        let valOccupants = {};
        if (activeEntityTicker && ARI && ARI.size) {
          const { occupants = {} } = ARI.toJS()[activeEntityTicker];
          valOccupants = occupants;
        }
        return valOccupants;
      };
      const valOccupants = getOccupants(activeEntityTicker, this.props.ARI);

      if (isEntityGrid) {
        rooms = (
          <EntityGrid
            locale={this.props.intl.locale}
            entities={activeEntityTicker && entities.get(activeEntityTicker).toJS()}
            handleGallery={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
            propertyTicker={activeEntityTicker}
            BookableErrorMessage={BookableErrorMessage}
            onSelect={({ propertyTicker, accommodation, ticker, type }) => {
              handleImpressionClickEvent(accommodation || ticker);
              this.handleSelectEntity({
                ticker: activeEntityTicker,
                entity: accommodation || ticker,
                originAccommodation,
                type,
              });
            }}
            buildImgUrl={buildImgUrl}
            loyalty={this.props.loyalty}
            deviceType={this.state.deviceType}
            userLoyaltyTier={this.props.loyaltyUser && this.props.loyaltyUser.tierTicker}
            handleModalContent={this.props.handleModalContent}
            handleCloseModal={this.props.handleCloseModal}
            compoundDiscounts={this.props.compoundDiscounts}
            linkToLoyaltyLogin={linkToLoyaltyLogin}
            occupants={valOccupants}
            onlineStoreHidePrice={onlineStoreHidePrice}
            taxesText={taxesText}
          />
        );
      } else {
        rooms = (
          <EntityCarousel
            locale={this.props.intl.locale}
            occupants={valOccupants}
            type="accommodation"
            entities={activeEntityTicker && entities.get(activeEntityTicker)}
            onSelect={({ accommodation, displayElementTicker, type }) => {
              handleImpressionClickEvent(accommodation);
              this.handleSelectEntity({
                ticker: activeEntityTicker,
                entity: accommodation,
                displayElementTicker,
                originAccommodation,
                type,
              });
            }}
            handleGallery={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
            propertyTicker={activeEntityTicker}
            handleScroll={handleScroll}
            roomRepresentationType={constants.ROOM_REPRESENTATION_TYPE.HORIZONTAL}
            accommodationSelectionBehavior={accommodationSelectionBehavior}
            windowWidth={windowWidth}
            fullWidth
            displayElements={filteredDisplayElements.filter(entityFilter)}
            showDisplayElements={isDisplayActive}
            propertyFiltersShown={
              propertyFilters &&
              propertyFilters.size > 0 &&
              showOccupationAlternatives === constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE
            }
            loyalty={this.props.loyalty}
            deviceType={this.state.deviceType}
            userLoyaltyTier={this.props.loyaltyUser && this.props.loyaltyUser.tierTicker}
            handleModalContent={this.props.handleModalContent}
            handleCloseModal={this.props.handleCloseModal}
            linkToLoyaltyLogin={linkToLoyaltyLogin}
            taxesText={taxesText}
          />
        );
      }
    }
    return rooms;
  };

  getResultQuantity = activeEntityTicker => {
    const { accommodations } = this.props;
    let lengthAccommodations = 0;
    if (accommodations && accommodations.size && accommodations.get(activeEntityTicker)) {
      lengthAccommodations = accommodations
        .get(activeEntityTicker)
        .toJS()
        .reduce((sum, accommodation) => {
          return accommodation.statusCode !== "UNAVAILABLE" ? sum + 1 : sum;
        }, 0);
    }
    const messageResult = lengthAccommodations > 1 ? "resultsFor" : "resultFor";
    if (lengthAccommodations > 0) {
      return `${lengthAccommodations} ${this.props.intl.formatMessage(msgs[messageResult])}`;
    }

    return "";
  };

  getTranslateForOccupants = (occupant, total) => {
    let message = "";

    if (total > 1) {
      switch (occupant) {
        case "child":
          message = "children";
          break;
        case "baby":
          message = "babies";
          break;
        default:
          message = `${occupant}s`;
          break;
      }
    } else {
      message = occupant;
    }
    return this.props.intl.formatMessage(msgs[message]);
  };

  getOccupantText = (value, initialOccupantType, textPrevious) => {
    const occupantValue = `${
      this.props.isPropertyAvailable && !this.props.isOccupationIgnored && value && value > 0
        ? `${value}`
        : ""
    }`;
    const occupantType =
      this.props.occupantRestriction === constants.OCCUPANT_RESTRICTION.TAKE_ALL_PEOPLE
        ? "guest"
        : initialOccupantType;
    const occupantText = `${value ? this.getTranslateForOccupants(occupantType, value) : ""}`;
    const occupantResult = `${occupantValue}${value && occupantValue ? " " : ""}${occupantText}`;

    if (occupantResult.length) {
      return `${textPrevious.length ? `${textPrevious} + ` : ""}${occupantResult}`;
    }
    return textPrevious;
  };

  getResultOccupants = () => {
    let result = "";
    const activeEntityTicker = this.props.activeEntity && this.props.activeEntity.ticker;
    if (activeEntityTicker && this.props.ARI && this.props.ARI.size) {
      const { occupants = {} } = this.props.ARI.toJS()[activeEntityTicker];
      const {
        ADULT: adultValue,
        BABY: babyValue,
        CHILD: childValue,
        TEENAGER: teenagerValue,
        SENIOR: seniorValue,
      } = occupants;

      const senior = (seniorValue && parseInt(seniorValue)) || 0;
      const adult = (adultValue && parseInt(adultValue)) || 0;
      const teenager = (teenagerValue && parseInt(teenagerValue)) || 0;
      const baby = (babyValue && parseInt(babyValue)) || 0;
      const child = (childValue && parseInt(childValue)) || 0;

      result = this.getOccupantText(senior, "senior", result);
      result = this.getOccupantText(adult, "adult", result);
      result = this.getOccupantText(teenager, "teenager", result);
      result = this.getOccupantText(child, "child", result);
      result = this.getOccupantText(baby, "baby", result);
    }
    return result;
  };

  handleShowOccupationAlternatives = () => {
    const showOccupationAlternatives =
      this.state.showOccupationAlternatives === constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED
        ? constants.SHOW_OCCUPATION_ALTERNATIVES.EXPANDED
        : constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED;
    this.setState({
      showOccupationAlternatives,
    });
  };

  getInventoryList = ({
    propertyTicker,
    propertyServices,
    accommodation,
    roomInventories,
    selectedPackage,
    linkToLoyaltyLogin,
    taxesText,
  }) => {
    return (
      <InventoryList
        propertyTicker={propertyTicker}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        accommodationTicker={accommodation.ticker}
        accommodationName={accommodation.name}
        calendarPriceVisibility={this.props.priceCalendar}
        cancelRelease={this.props.cancelRelease}
        currency={this.props.currency}
        handleCloseModal={this.props.handleCloseModal}
        handleModalContent={this.props.handleModalContent}
        handleScroll={this.props.handleScroll}
        inventories={roomInventories}
        inventoryGroupingCriteria={this.props.inventoryGroupingCriteria}
        maxBookableRooms={this.props.maxBookableRooms}
        numberOfNights={this.props.numberOfNights}
        numberOfRoomsLeftLimit={this.props.numberOfRoomsLeftLimit}
        onSelect={({ inventory, numberOfUnits }) => {
          this.handleInventorySelected({
            propertyTicker,
            propertyServices: propertyServices,
            inventory,
            numberOfUnits,
            selectedPackage,
          });
        }}
        propertyServices={propertyServices}
        roomDetailRepresentationType={constants.ROOM_DETAIL_REPRESENTATION_TYPE.FULL}
        showBookingOptionSummary={this.props.showBookingOptionSummary}
        showDiscountsCalculation={this.props.showDiscountsCalculation}
        submitBookingForm={this.handleSubmitBookingForm}
        showCalendar={this.props.showCalendar}
        cancellationRestrictions={this.props.cancellationRestrictions}
        cancellationPoliciesInfo={this.props.cancellationPoliciesInfo}
        getFirstNightCost={this.getFirstNightCost}
        isCartMaxItemsReached={this.props.isCartMaxItemsReached}
        loyalty={this.props.loyalty}
        deviceType={this.state.deviceType}
        userLoyaltyTier={this.props.loyaltyUser && this.props.loyaltyUser.tierTicker}
        depositRequiredTextConfiguration={this.props.depositRequiredTextConfiguration}
        depositNotRequiredTextConfiguration={this.props.depositNotRequiredTextConfiguration}
        linkToLoyaltyLogin={linkToLoyaltyLogin}
        taxesText={taxesText}
      />
    );
  };

  formatPackageRooms = (activeProperty, entity, ARI, linkToLoyaltyLogin, taxesText) => {
    if (
      !entity ||
      entity.type === constants.ACTIVE_ENTITY_TYPE.CHAIN ||
      (entity.type !== constants.ACTIVE_ENTITY_TYPE.PACKAGE && !ARI) ||
      !this.props.inventories ||
      !activeProperty
    ) {
      return [];
    }
    const propertyTicker = activeProperty.get("ticker");
    const inventories = this.props.inventories.get(propertyTicker);
    if (!inventories) {
      return [];
    }
    const accommodations = ARI.get(propertyTicker).get("accommodations").toJS();
    const property = ARI.get(propertyTicker);

    const packageAccomodations = Object.keys(accommodations).reduce((results, ticker) => {
      const accommodation = accommodations[ticker];
      const inventories = accommodation.inventories.filter(inventory =>
        entity.inventories.includes(inventory)
      );
      if (inventories.length) {
        results.push({
          ...accommodation,
          inventories,
        });
      }
      return results;
    }, []);
    const rooms = packageAccomodations.reduce((results, accommodation) => {
      const roomInventories = accommodation.inventories.reduce((result, inventoryTicker) => {
        const inventoryProperty = inventories.find(
          inventory => inventory.get("ticker") === inventoryTicker
        );
        if (inventoryProperty) {
          return result.push(inventoryProperty);
        }
        return result;
      }, new List());
      const lowerInventory = roomInventories
        .filter(inventory => inventory.get("statusCode") === "AVAILABLE")
        .minBy(inventory => inventory.get("totalRate"));

      results.push({
        ticker: accommodation.ticker,
        image: accommodation.media && accommodation.media[0] && accommodation.media[0].url,
        name: accommodation.name,
        description: accommodation.description,
        price: (
          <Amount
            amount={lowerInventory ? lowerInventory.get("totalRate") : null}
            integerClassName={styles.amount}
            decimalClassName={styles.decimal}
          />
        ),
        inventories: this.getInventoryList({
          propertyTicker,
          propertyServices: property.get("services"),
          accommodation,
          roomInventories: new Map().set(
            propertyTicker,
            roomInventories.sortBy(inventory => inventory.get("totalRate"))
          ),
          selectedPackage: entity,
          linkToLoyaltyLogin,
          taxesText,
        }),
        statusCode: lowerInventory ? lowerInventory.get("statusCode") : "UNAVAILABLE",
      });
      return results;
    }, []);
    return _.orderBy(rooms, "price.props.amount");
  };

  //------------------------ NEW METHODS  -----------------------------\\

  render() {
    const {
      propertyList,
      startDate,
      endDate,
      messages,
      ariLoading,
      currency,
      isPropertyAvailable,
      propertyTicker,
      showElementsConfig,
      handleModalContent,
      customStyles,
      handleCloseModal,
      accommodations,
      inventories,
      propertyActiveTab,
      propertyName,
      isAgent,
      affiliate,
      numberOfNights,
      availableCurrencies,
      availableLocales,
      propertyContact,
      summaryCart,
      promoCode,
      toggleBookingFormSummary,
      cart: { bookingTotalRate, reservations } = {},
      activeEntity,
      activeDisplayElement,
      isPropertyChain,
      isDisplayActive,
      displayActiveElements,
      isButtonBarActive,
      propertyTabs,
      isTabFiltersCollapsed,
      isOccupationIgnored,
      propertyPromotionsImmutable,
      activePropertyTicker,
      windowWidth,
      renderDisplayElementAsModal,
      isEntityGrid,
      showNewBookingForm,
      ARI,
      promotionsListMode,
      channel,
      origin,
      brand,
      taxesText,
      promoCodes,
    } = this.props;
    const {
      allAccommodationsFiltered,
      showOccupationAlternatives,
      selectedElementOutside,
      deviceType,
      selectedRoom,
    } = this.state;
    const element = document.body;
    const locale = this.props.intl.locale;
    const { largeBookingForm, isPropertyCalendarOpened } = this.state;
    const {
      handleChangeConfiguration,
      handleChangeLocale,
      handleGoToCheckout,
      handleRemoveReservation,
    } = this;

    const isActiveEntityChain =
      (isPropertyChain && !activeEntity) || (activeEntity && activeEntity.children);
    const activeEntityType = activeEntity && activeEntity.type;
    const activeEntityTicker = activeEntity && activeEntity.ticker;
    const activeProperty = this.props.activePropertyDataFullRoom;
    const isChain = activeEntityType === constants.ACTIVE_ENTITY_TYPE.CHAIN;
    const onBack =
      activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL
        ? event =>
            this.handleResetProperty({
              event,
              propertyTicker: this.props.propertyTicker,
            })
        : event =>
            this.handleResetAccommodation({
              event,
              propertyTicker: activeProperty && activeProperty.get("ticker"),
            });

    const hasBackButton =
      activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL ? isPropertyChain : true;

    const SummaryCartComponent = isActiveEntityChain ? null : (
      <SummaryCart
        cart={summaryCart}
        currency={currency}
        handleSubmit={handleGoToCheckout}
        handleRemoveReservation={handleRemoveReservation}
        reservations={summaryCart.reservations}
        reservationsLenght={summaryCart.reservations.length}
        locale={locale}
      />
    );

    const stickyMapClasses = hasBackButton =>
      classnames(
        styles.stickyMap,
        showNewBookingForm
          ? [styles.mapViewNewBF, styles.stickyMapNewBF]
          : [styles.mapViewOldBF, styles.stickyMapOldBF],
        styles.mapView,
        styles.active,
        hasBackButton || activeDisplayElement?.type === "MAP" ? null : styles.stickyMap2,
        activeDisplayElement?.type === "INFO" ? styles.stickyMap2 : ""
      );

    const stickyRightSidebarClasses = classnames(
      "wbkv9-RoomSelection-verticalPromotionListContainer",
      styles.verticalPromotionListContainer,
      !showElementsConfig.showPropertyMap && styles.large
    );

    const resultsContainerClasses = classnames(
      "wbkv9-RoomSelection-resultsContainer",
      styles.resultsContainer,
      styles.hasMap
    );

    const leftContainerClasses = classnames(
      "wbkv9-RoomSelection-hotelCardContainer",
      styles.hotelCardContainer,
      largeBookingForm === 1 && styles.largeBookingForm,
      largeBookingForm === 2 && styles.extraLargeBookingForm,
      "hasMap"
    );

    const occupationAlternativesClasses = classnames(styles.occupationAlternatives);

    const occupationAlternativesInGridClasses = classnames(styles.occupationAlternativesInGrid);

    const occupationAlternativesContainerClasses = classnames(
      styles.occupationAlternativesContainer
    );

    const occupationAlternativesTextClasses = classnames(styles.occupationAlternativesText);

    const occupationAlternativesArrowClasses = classnames(styles.occupationAlternativesArrow);

    const otherOptionContainerArrowClasses = classnames(styles.hotelOtherOptionContainerArrow);

    const occupationAlternativesArrowCollapsedClasses = classnames(
      styles.occupationAlternativesArrowCollapsed
    );

    const hotelResultsClasess = classnames(styles.hotelResults);

    const hotelResultsIsGridClasess = classnames(styles.hotelResultsIsGrid);

    const resultsQuantity = classnames(styles.hotelResultsQuantity);

    const resultsOccupants = classnames(styles.hotelResultsOccupants);

    const marginFilterInGrid = classnames(styles.marginFilterInGrid);

    const occupationAlternativesWithFilterInGridClasses = classnames(
      styles.occupationAlternativesWithFilterInGrid
    );

    const occupationAlternativesWithFilterNoResultsInGridClasses = classnames(
      styles.occupationAlternativesWithFilterNoResultsInGrid
    );

    const occupationAlternativesWithFilterInListClasses = classnames(
      styles.occupationAlternativesWithFilterInList
    );

    const threeColumnContainerClasses = classnames(
      "wbkv9-RoomSelection-listView",
      styles.listView,
      styles.active,
      "wbkv9-RoomSelection-listView--active"
    );

    const FilterDiv = styled.div`
      ${media.down.mdl`
        margin-left: ${props => (!props.isEntityGrid ? "0" : "10px")} !important;
      `}
    `;

    const backArrow = ({ onBack, ...props }) => (
      <OnBackIconContainer {...props} onClick={onBack}>
        <ArrowBackIcon />
      </OnBackIconContainer>
    );

    const entityResultHeaderContainer = props =>
      activeEntityType !== constants.ACTIVE_ENTITY_TYPE.CHAIN && <EntityResultHeader {...props} />;

    const isGoogleChannel = () => channel === constants.CHANNEL.GOOGLE;
    const hasTaxesIncludedFeesExcluded = () =>
      taxesText === constants.TAXES_TEXT.TAXES_INCLUDED_FEES_EXCLUDED;
    const validTaxesText = isGoogleChannel() && hasTaxesIncludedFeesExcluded() && taxesText;

    const entityFilter = filterDisplayElement({
      activeEntity: { type: constants.ACTIVE_ENTITY_TYPE.ACCOMMODATION },
      isPropertyChain,
      type: constants.DISPLAY_CONDITION_TYPE.ENTITY,
    });
    const linkToLoyaltyLogin = getLinkToLoyaltyLogin({
      brand,
      propertyTicker,
      locale,
      queryParams: {
        datein: format(startDate, "dd-MM-yyyy"),
        dateout: format(endDate, "dd-MM-yyyy"),
        channel,
        origin,
        affiliate,
        setconversion: currency,
        locale,
        prom: promoCodes,
      },
      bookingFormInitialValues: this.props.bookingFormInitialValues,
    });

    let rooms = this.getRooms({
      entities: accommodations,
      entityFilter,
      activeEntityTicker,
      showOccupationAlternatives,
      channel,
      origin,
      affiliate,
      currency,
      linkToLoyaltyLogin,
      taxesText: validTaxesText,
    });
    let allRooms = this.getRooms({
      entities: allAccommodationsFiltered,
      entityFilter,
      activeEntityTicker,
      originAccommodation: constants.OCCUPATION_ALTERNATIVES,
      showOccupationAlternatives,
      channel,
      origin,
      affiliate,
      currency,
      linkToLoyaltyLogin,
      taxesText: validTaxesText,
    });
    const showCollapsedArrowClasses =
      constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED === showOccupationAlternatives
        ? occupationAlternativesArrowCollapsedClasses
        : "";
    let inventoryList = undefined;
    if (activeEntityType === constants.ACTIVE_ENTITY_TYPE.ACCOMMODATION) {
      const immutableActiveProperty =
        this.props.propertyList &&
        this.props.propertyList.size > 0 &&
        this.props.propertyList.find(it => it.get("ticker") === activeProperty.get("ticker"));

      inventoryList = this.getInventoryList({
        propertyTicker: activeProperty.get("ticker"),
        propertyServices: immutableActiveProperty.get("services"),
        accommodation: activeEntity,
        roomInventories: inventories,
        linkToLoyaltyLogin,
        taxesText: validTaxesText,
      });
    }
    const roomsPackage = this.formatPackageRooms(
      activeProperty,
      activeEntity,
      ARI,
      linkToLoyaltyLogin,
      validTaxesText
    );
    const quantityAllAccommodations = this.getResultQuantity(activeEntityTicker);
    const filters = propertyTabs && propertyTabs.size > 0 && (
      <FilterDiv
        className={classnames([`${isEntityGrid && !isChain ? marginFilterInGrid : ""}`])}
        isEntityGrid={!!isEntityGrid}>
        <TabFilter
          tabFilters={propertyTabs}
          onChange={this.handleChangeTab}
          onSelectorChange={this.handleSelectorChangeTab}
          propertyActiveTab={propertyActiveTab}
          isTabFiltersCollapsed={isTabFiltersCollapsed}
        />
      </FilterDiv>
    );
    const resultsSummary = !filters && quantityAllAccommodations.length > 0 && (
      <div
        className={classnames([
          "wbkv9-room-selection-hotel-results-summary",
          `${isEntityGrid && !isChain ? hotelResultsIsGridClasess : ""}`,
          hotelResultsClasess,
        ])}>
        <span className={classnames(resultsQuantity)}>{quantityAllAccommodations}</span>
        <span className={classnames(resultsOccupants)}>{this.getResultOccupants()}</span>
      </div>
    );
    const hasPromotions = this.props.propertyPromotions && this.props.propertyPromotions.length > 0;

    const buttonBar = isButtonBarActive && (
      <EngineButtonBar
        onOpenPromotions={this.handleOpenPromotions}
        onOpenMap={this.handleOpenMap}
        onOpenCalendar={() =>
          this.handleOpenPropertyCalendar({
            propertyTicker: this.props.propertyTicker,
          })
        }
        isPropertyChain={isPropertyChain}
        showPromotions={hasPromotions}
        showAvailability={
          activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL && this.props.showCalendar
        }
        displayElements={
          displayActiveElements &&
          displayActiveElements.filter(
            element => element.type === constants.DISPLAY_ELEMENT_TYPE.CUSTOM
          )
        }
        onSelectDisplay={this.handleSelectActiveDisplayElement}
        propertyPromotions={this.props.propertyPromotions}
        carousel={promotionsListMode === constants.PROMOTIONSLISTMODE.SLIDESHOW}
      />
    );
    const showThirdColumn = (isActiveEntityChain && hasPromotions) || !isActiveEntityChain;
    const stickyTopNewBookingForm = this.props.loyalty ? "185px" : "100px";
    const verticalPromotionList = showThirdColumn && (
      <div id="stickyVerticalPromotionList" className={stickyRightSidebarClasses}>
        <StickyRightContainer
          fullWidth
          promotions={this.props.propertyPromotionsImmutable}
          styles={styles}
          scrollElement={Element}
          mode={"fullWidth"}
          topOffset={-70}
          currency={this.props.currency}
          isSticky={window && window.innerWidth >= 900}
          stickyStyle={{ top: showNewBookingForm ? stickyTopNewBookingForm : "20px", zIndex: 3 }}
          summaryCart={SummaryCartComponent}
          showPromos={this.props.showPromos}
          textColor={`#${this.props.customStyles.get("bookingFormButtonBackgroundColor")}`}
          inverseTextColor={`#${this.props.customStyles.get("bookingFormButtonOppositeColor")}`}
        />
      </div>
    );
    const ContextualDisplayContainer = (
      <ContextualDisplay
        hotelSelected={this.state.hotelSelected}
        mapContent={showElementsConfig.showPropertyMap && this.generatePropertyMapView()}
        activeEntity={activeEntity}
        isActiveEntityChain={isActiveEntityChain}
        activeDisplayElement={activeDisplayElement}
        isPropertyChain={isPropertyChain}
        primaryColor={customStyles.get("bookingFormButtonBackgroundColor")}
        handleGallery={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
        onSelectElement={this.handleSelectActiveDisplayElement}
        selectedElementOutside={selectedElementOutside}
        displayElements={displayActiveElements}
        onOpenCalendar={({ propertyTicker }) =>
          this.handleOpenPropertyCalendar({
            propertyTicker,
            onCalendarClose: () =>
              this.handleSelectActiveDisplayElement({
                element: "info",
                selectedOutside: true,
              }),
          })
        }
        handleModalContent={handleModalContent}
        handleCloseModal={handleCloseModal}
        renderAsModal={renderDisplayElementAsModal}
        windowWidth={windowWidth}
        EntityResultHeaderContainer={entityResultHeaderContainer({
          onBack: onBack,
          onImageClick: handleGallery(this.props.handleModalContent, this.props.handleGallery),
          nature: this.props.resultHeaderNatureUI,
          entity: activeEntity,
          subtitle: "",
        })}
        BackArrow={backArrow({ onBack: onBack, hasBackButton: hasBackButton })}
      />
    );
    const displayContainer =
      (isDisplayActive && (
        <StickyMapContainer
          id="stickyMap"
          className={stickyMapClasses(hasBackButton)}
          hasBackButton={hasBackButton}>
          <DisplayContainer
            isActiveEntityChain={isActiveEntityChain}
            isSticky={window && window.innerWidth >= 900}
            topOffset={-70}
            onStickyStateChange={mapResizeHandler}
            stickyStyle={{ top: showNewBookingForm ? stickyTopNewBookingForm : "40px" }}
            stickyTopClassName={styles.stickyMapInnerContainer}>
            <EntityResultHeaderComponentContainer>
              {entityResultHeaderContainer({
                onBack: onBack,
                onImageClick: handleGallery(
                  this.props.handleModalContent,
                  this.props.handleGallery
                ),
                nature: this.props.resultHeaderNatureUI,
                entity: activeEntity,
                hasBackButton: hasBackButton,
                subtitle: "",
              })}
            </EntityResultHeaderComponentContainer>
            {ContextualDisplayContainer}
          </DisplayContainer>
        </StickyMapContainer>
      )) ||
      (renderDisplayElementAsModal && ContextualDisplayContainer);

    const messagesListTopInventory =
      messages && messages.get(constants.MESSAGE_POSITIONS.TOP_INVENTORY_STEP_1);
    const messageTopInventory = messagesListTopInventory && messagesListTopInventory.get(0);
    const hotelCardContainer = (
      <div id="hotelCardContainer" className={leftContainerClasses}>
        <div
          id="innerContainer"
          className={classnames("wbkv9-RoomSelection-innerContainer", styles.innerContainer)}>
          {isOccupationIgnored && (
            <StyledNotification
              className="wbkv9-StyledNotification"
              id={constants.SPECIAL_MESSAGE_TYPES.OCCUPATION_MESSAGE}
              position={constants.MESSAGE_POSITIONS.TOP_INVENTORY_STEP_1}
              text={constants.SPECIAL_MESSAGE_TYPES.OCCUPATION_MESSAGE}
              type={"warning"}
              propertyTicker={activePropertyTicker}
              hideIcon
              closeIcon
              borderRadius
            />
          )}

          {messageTopInventory && (
            <StyledNotification
              className="wbkv9-StyledNotification"
              id={messageTopInventory.get("id")}
              position={messageTopInventory.get("position")}
              text={
                <span dangerouslySetInnerHTML={renderHTML(messageTopInventory.get("content"))} />
              }
              type={messageTopInventory.get("type").toLowerCase()}
              propertyTicker={propertyTicker}
              hideIcon
              closeIcon
              borderRadius
            />
          )}

          {!isPropertyAvailable && (
            <StyledAvailabilityNotification
              hide={isPropertyCalendarOpened}
              startDate={startDate}
              endDate={endDate}
              isPropertyAvailable={isPropertyAvailable}
              numberOfNights={numberOfNights}
            />
          )}

          {propertyList.length > 0 && <PriceWidgetPlaceholder propertyList={propertyList} />}
          {activeEntityType === constants.ACTIVE_ENTITY_TYPE.CHAIN && (
            <PropertyList
              propertyList={propertyList}
              propertiesWithInvalidOccupations={this.props.propertiesWithInvalidOccupations}
              numberOfNights={numberOfNights}
              handleGallery={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
              handleSelectProperty={this.handleSelectProperty}
              onOpenCalendar={({ propertyTicker }) =>
                this.handleOpenPropertyCalendar({
                  propertyTicker,
                })
              }
              entity={activeEntity}
              onMouseEnter={propertyTicker => this.setState({ hotelSelected: propertyTicker })}
              onMouseLeave={() => this.setState({ hotelSelected: null })}
              nature={this.props.resultHeaderNatureUI}
              buttonBar={buttonBar}
              showCalendar={this.props.showCalendar}
              markerSelected={this.state.markerSelected}
              currency={this.props.currency}
              withGrid={isEntityGrid}
              isPropertyChain={isPropertyChain}
              windowWidth={windowWidth}
            />
          )}
          {activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL && rooms && (
            <Property
              entity={activeEntity}
              nature={this.props.resultHeaderNatureUI}
              onImageClick={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
              onBack={this.handleResetProperty}
              filters={filters}
              resultsSummary={resultsSummary}
              rooms={rooms}
              buttonBar={buttonBar}
              isMainPropertyChain={isPropertyChain}
              basePropertyTicker={this.props.propertyTicker}
              withGrid={isEntityGrid}
            />
          )}
          {activeEntityType === constants.ACTIVE_ENTITY_TYPE.ACCOMMODATION && (
            <Room
              entity={activeEntity}
              nature={this.props.resultHeaderNatureUI}
              onImageClick={handleGallery(this.props.handleModalContent, this.props.handleGallery)}
              onBack={this.handleResetAccommodation}
              propertyName={activeProperty && activeProperty.get("name")}
              propertyCity={
                activeProperty &&
                activeProperty.get("contact") &&
                activeProperty.get("contact").get("city")
              }
              propertyTicker={activeProperty && activeProperty.get("ticker")}
              filters={filters}
              resultsSummary={resultsSummary}
              buttonBar={buttonBar}>
              {inventoryList}
            </Room>
          )}
          {activeEntityType === constants.ACTIVE_ENTITY_TYPE.PACKAGE &&
          roomsPackage &&
          roomsPackage.length ? (
            <Room
              entity={activeEntity}
              nature={this.props.resultHeaderNatureUI}
              onImageClick={this.handleGallery}
              onBack={this.handleResetAccommodation}
              propertyName={activeProperty && activeProperty.get("name")}
              propertyCity={
                activeProperty &&
                activeProperty.get("contact") &&
                activeProperty.get("contact").get("city")
              }
              propertyTicker={activeProperty && activeProperty.get("ticker")}
              filters={filters}
              resultsSummary={resultsSummary}
              buttonBar={buttonBar}>
              <Package
                onSelectRoomChange={this.handleSelectedRoomChange}
                selectedRoom={selectedRoom || roomsPackage[0]}
                currency={currency}
                element={element}
                onImageClick={(element, title, description) =>
                  this.handleImagePackage(element, title, description)
                }
                showCollapsedRooms={true}
                deviceType={deviceType}
                roomDenominationSingular="ROOMS_SINGULAR"
                roomDenominationPlural="ROOMS"
                rooms={roomsPackage}
              />
            </Room>
          ) : (
            ""
          )}
          {constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE !== showOccupationAlternatives &&
            !_.isEmpty(allAccommodationsFiltered) &&
            allRooms && (
              <>
                <div
                  className={classnames([
                    isEntityGrid && !isChain && occupationAlternativesInGridClasses,
                    occupationAlternativesClasses,
                    filters &&
                      isEntityGrid &&
                      accommodations.length &&
                      occupationAlternativesWithFilterInGridClasses,
                    filters &&
                      isEntityGrid &&
                      !accommodations.length &&
                      occupationAlternativesWithFilterNoResultsInGridClasses,
                    filters && !isEntityGrid && occupationAlternativesWithFilterInListClasses,
                  ])}>
                  <span
                    className={classnames(occupationAlternativesContainerClasses)}
                    onClick={this.handleShowOccupationAlternatives}>
                    <span className={classnames(occupationAlternativesTextClasses)}>
                      <FormattedMessage {...msgs.otherOptions} />
                    </span>
                    <span className={classnames(otherOptionContainerArrowClasses)}>
                      {
                        <span
                          className={classnames([
                            occupationAlternativesArrowClasses,
                            showCollapsedArrowClasses,
                          ])}>
                          <ArrowContainer>
                            <ArrowDropDownIcon />{" "}
                          </ArrowContainer>
                        </span>
                      }
                    </span>
                  </span>
                </div>
                {showOccupationAlternatives !== constants.SHOW_OCCUPATION_ALTERNATIVES.COLLAPSED &&
                  activeEntityType === constants.ACTIVE_ENTITY_TYPE.HOTEL &&
                  allRooms && (
                    <Property
                      nature={constants.RESULT_HEADER_NATURE.LARGE}
                      entity={activeEntity}
                      onImageClick={handleGallery(
                        this.props.handleModalContent,
                        this.props.handleGallery
                      )}
                      onBack={this.handleResetProperty}
                      rooms={allRooms}
                      isMainPropertyChain={isPropertyChain}
                      basePropertyTicker={this.props.propertyTicker}
                      withGrid={isEntityGrid}
                    />
                  )}
              </>
            )}
          <FooterContainer
            className={styles.fixedFooter}
            arePromosBeingRendered={propertyPromotionsImmutable.size >= 1}>
            <Footer
              fullWidth
              isAgentLogged={isAgent}
              affiliate={affiliate}
              propertyName={propertyName}
              propertyContact={propertyContact}
              handleMap={this.handleOpenMap}
              showLanguage={showElementsConfig.showLanguageSelector}
              showCurrency={showElementsConfig.showCurrencySelector}
              locale={locale}
              currency={currency}
              locales={availableLocales}
              currencies={availableCurrencies}
              onLanguageChange={handleChangeLocale}
              onCurrencyChange={handleChangeConfiguration}
              promoCode={promoCode}
              toggleBookingFormSummary={toggleBookingFormSummary}
              handleModalContent={handleModalContent}
              handleCloseModal={handleCloseModal}
              showAgentLogin={this.props.showAgentLogin}
            />
          </FooterContainer>
        </div>

        {ariLoading && <ARILoader />}
      </div>
    );

    const firstColumn = displayContainer;
    const secondColumn = hotelCardContainer;
    const thirdColumn = verticalPromotionList;
    return (
      <div
        className={classnames(
          "wbkv9-RoomSelection",
          styles.container,
          ariLoading && styles.loading
        )}>
        <div className="RoomSelection-placeholder" />
        <div className={threeColumnContainerClasses}>
          <div id="resultsContainer" className={resultsContainerClasses}>
            {thirdColumn}

            {secondColumn}

            {firstColumn}
          </div>
        </div>

        {Boolean(reservations?.size > 0) && (
          <div className={classnames(styles.fixedCartContainer)}>
            <FixedCart
              currency={currency}
              backgroundColor={"#" + customStyles.get("bookingFormButtonBackgroundColor")}
              color={"#" + customStyles.get("bookingFormButtonOppositeColor")}
              totalInBasket={
                <FormattedNumber
                  value={bookingTotalRate}
                  minimumFractionDigits={2}
                  maximumFractionDigits={2}
                />
              }
              functionOnClick={handleGoToCheckout}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    createStructuredSelector({
      bookingFormInitialValues: bookingFormInitialValuesSelector,
      arePromoCodesBeingApplied: arePromoCodesBeingAppliedSelector,
      activePropertyTicker: activePropertyTickerSelector,
      accommodations: accommodationsSelector,
      propertyAriAll: selectors.propertyARIAllSelector,
      allAccommodations: allAccommodationsSelector,
      inventories: inventoriesSelector,
      bookingFormFields: bookingFormFieldsSelector,
      propertyList: selectors.propertyListSelector,
      propertyListAll: propertyListAllSelector,
      showOccupationAlternatives: showOccupationAlternativesSelector,
      numberOfRoomsLeftLimit: selectors.numberOfRoomsLeftLimitSelector,
      numberOfNights: numberOfNightsSelector,
      maxBookableRooms: selectors.maxBookableRoomsSelector,
      inventoryGroupingCriteria: selectors.inventoryGroupingCriteriaSelector,
      activeChildrenMap: activeChildrenMapSelector,
      activeRooms: activeRoomsSelector,
      activePropertyDataFullRoom: activePropertyDataFullRoomSelector,
      activePropertyARIFullRoom: activePropertyARIFullRoomSelector,
      configuration: selectors.configurationSelector,
      ARI: selectors.propertyARISelector,
      propertyData: selectors.propertyDataSelector,
      bookingForm: bookingFormSelector,
      reservations: selectors.reservationsSelector,
      startDate: selectors.startDateSelector,
      endDate: selectors.endDateSelector,
      propertyTicker: selectors.propertyTickerSelector,
      ariLoading: selectors.ariLoadingSelector,
      messages: selectors.messagesSelector,
      currency: selectors.currencySelector,
      reservation: selectors.reservationSelector,
      iframeMode: selectors.iframeModeSelector,
      isPropertyAvailable: selectors.isPropertyAvailableSelector,
      showElementsConfig: selectors.showElementsConfigSelector,
      cancelRelease: selectors.cancelReleaseSelector,
      invalidPayments: selectors.invalidPaymentsSelector,
      expandFirstProperty: selectors.expandFirstPropertySelector,
      expandedBookables: selectors.expandedBookablesSelector,
      entityTypeBookables: selectors.entityTypeBookablesSelector,
      customStyles: selectors.customStylesSelector,
      externalConfiguration: selectors.externalConfigurationSelector,
      propertyTabs: selectors.propertyTabsSelector,
      propertyActiveTab: selectors.propertyActiveTabSelector,
      deviceInfo: selectors.deviceInfoSelector,
      roomDetailRepresentationType: selectors.roomDetailRepresentationTypeSelector,
      roomRepresentationType: selectors.roomRepresentationTypeSelector,
      propertyName: selectors.propertyNameSelector,
      logos: selectors.logosSelector,
      hotelSiteURL: selectors.hotelSiteURLSelector,
      propertyType: selectors.propertyTypeSelector,
      availableCurrencies: selectors.availableCurrenciesSelector,
      locale: selectors.localeSelector,
      availableLocales: selectors.availableLocalesSelector,
      cart: selectors.cartSelector,
      showBookingOptionSummary: selectors.showBookingOptionSummarySelector,
      showDiscountsCalculation: selectors.showDiscountsCalculationSelector,
      propertyContact: selectors.propertyContactSelector,
      isWithotel: selectors.isWithotelSelector,
      gaData: selectors.gaDataSelector,
      summaryCart: summaryCartSelector,
      promoCodes: promoCodesSelector,
      propertySelectionBehavior: propertySelectionBehaviorSelector,
      accommodationSelectionBehavior: accommodationSelectionBehaviorSelector,
      openCalendar: openCalendarSelector,
      origin: selectors.originSelector,
      isPropertyChain: selectors.isPropertyChainSelector,
      defaultLocale: selectors.defaultLocaleSelector,
      customDomains: customDomainsSelector,
      promoCode: selectors.promoCodeSelector,
      expandedPromotions: selectors.expandedPromotionsSelector,
      promotionsListMode: selectors.promotionsListMode,
      propertiesWithInvalidOccupations: selectors.propertiesWithInvalidOccupationsSelector,
      priceCalendar: selectors.priceCalendarSelector,
      bookableCardSize: bookableCardSizeSelector,
      activeEntity: activeEntitySelector,
      activeDisplayElement: activeDisplayElementSelector,
      isDisplayActive: selectors.isDisplayActiveSelector,
      displayElementParam: displayElementParamSelector,
      displayActiveElements: displayActiveElementsSelector,
      resultHeaderNatureUI: resultHeaderNatureUISelector,
      isButtonBarActive: isButtonBarActiveSelector,
      isAgent: selectors.isAgentSelector,
      affiliate: selectors.affiliateSelector,
      propertyPromotionsImmutable: propertyPromotionsImmutableSelector,
      propertyPromotions: propertyPromotionsSelector,
      isTabFiltersCollapsed: selectors.isTabFiltersCollapsedUISelector,
      isOccupationIgnored: isOccupationIgnoredSelector,
      showAgentLogin: selectors.showAgentLoginSelector,
      showPromos: selectors.showPromosSelector,
      showCalendar: showCalendarSelector,
      showCalendarByUrl: showCalendarByUrlSelector,
      showUnavailableModalMessage: showUnavailableModalMessageSelector,
      cancellationRestrictions: selectors.cancellationRestrictionsInventorySelector,
      cancellationPoliciesInfo: selectors.cancellationPoliciesInfoInventorySelector,
      renderDisplayElementAsModal: renderDisplayElementAsModalSelector,
      guestAges: guestAgesSelector,
      roomSelectionViewType: roomSelectionViewTypeSelector,
      hasPremiumMap: hasPremiumMapSelector,
      windowWidth: selectors.widthSelector,
      channel: selectors.channelSelector,
      filteredDisplayElements: filteredDisplayElementsSelector,
      propertyFilters: propertyFiltersSelector,
      assistedMode: assistedModeSelector,
      isEntityGrid: isEntityGridSelector,
      showNewBookingForm: showNewBookingFormSelector,
      isCartMaxItemsReached: isCartMaxItemsReachedSelector,
      showCollapsedRoom: showCollapsedRoomSelector,
      loyalty: selectors.loyaltySelector,
      restoredSession: selectors.restoredSessionSelector,
      depositRequiredTextConfiguration: selectors.depositRequiredTextConfigurationSelector,
      depositNotRequiredTextConfiguration: selectors.depositNotRequiredTextConfigurationSelector,
      compoundDiscounts: selectors.compoundDiscountsSelector,
      bMindTracker: selectors.bMindTrackerSelector,
      brand: selectors.brandSelector,
      onlineStoreHidePrice: selectors.onlineStoreHidePriceSelector,
      showPromoCodesAppliedPopupDescriptions: showPromoCodesAppliedPopupDescriptionsSelector,
      taxesText: selectors.taxesTextSelector,
      occupantRestriction: occupantRestrictionSelector,
    }),
    dispatch =>
      bindActionCreators(
        {
          ...actions,
          ...appActions,
          ...reservationActions,
        },
        dispatch
      )
  )(injectIntl(RoomSelection))
);

//TODO: Correct proptypes
// RoomSelection.propTypes = {
//   bookingFormInitialValues: PropTypes.object.isRequired,
//   addAlert: React.PropTypes.func,
//   handleGallery: React.PropTypes.func,
//   bookingFormFields: PropTypes.object.isRequired,
//   activeChildrenMap: PropTypes.object.isRequired,
//   propertyList: PropTypes.array,
//   childrenToggled: PropTypes.func,
//   activeRooms: PropTypes.object,
//   reservations: PropTypes.object,
//   roomSelected: PropTypes.func,
//   changePropertyTicker: PropTypes.func,
//   addReservation: PropTypes.func,
//   propertyTicker: PropTypes.string,
//   reservation: PropTypes.object,
//   iframeMode: PropTypes.bool,
//   isPropertyAvailable: PropTypes.bool,
//   accommodations: PropTypes.object,
//   guestAges: PropTypes.array,
//   propertyFilters: PropTypes.bool.object,
// };
